import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
import { Radar } from 'react-chartjs-2'

import { translate } from '../../i18n/Library/evaluations'
import { useIntl } from 'react-intl'

const label = {
	es: {
		boss: 'Jefe',
		pairs: 'Pares',
		team: 'Equipo'
	},
	pt: {
		boss: 'Chefe',
		pairs: 'Pares',
		team: 'Equipe'
	}
}


export function ChartEvaluation({ evaluation, template }) {
	ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const data = {
		labels: template.criteria.sort((a, b) => a.id - b.id).map(item => `${translate[language][item.name] || item.name }`),
		datasets: [
			{
				label: label[language].boss,
				data: evaluation.bossResults.sort((a, b) => a.criteriaId - b.criteriaId).map(item => item.evaluation),
				fill: true,
				backgroundColor: 'rgba(122, 107, 232, 0.4)',
				borderColor: 'rgb(3, 6, 23)',
				borderWidth: 1,
				pointBackgroundColor: 'rgba(122, 107, 232, 1)',
				pointBorderColor: 'rgb(3, 6, 23)',
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgba(122, 107, 232, 1)',
			},
			{
				label:label[language].team,
				data: evaluation.teamResults.sort((a, b) => a.criteriaId - b.criteriaId).map(item => item.evaluation),
				fill: true,
				backgroundColor: 'rgba(65, 200, 255, 0.4)',
				borderColor: 'rgb(3, 6, 23)',
				borderWidth: 1,
				pointBackgroundColor: 'rgba(65, 200, 255, 1)',
				pointBorderColor: 'rgb(3, 6, 23)',
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgba(65, 200, 255, 1)',
			},
			{
				label: label[language].pairs,
				data: evaluation.peerResults.sort((a, b) => a.criteriaId - b.criteriaId).map(item => item.evaluation),
				fill: true,
				backgroundColor: 'rgba(5, 200, 170, 0.4)',
				borderColor: 'rgb(3, 6, 23)',
				borderWidth: 1,
				pointBackgroundColor: 'rgba(5, 200, 170, 1)',
				pointBorderColor: 'rgb(3, 6, 23)',
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgba(5, 200, 170, 1)',
			},
		],
	}

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				position: 'bottom',
				display: true,
				labels: {
					padding: 20,
					usePointStyle: true,
					boxWidth: 15,
					boxHeight: 8,
					useBorderRadius: true
				}
			},
		},
		scales: { 
			r: { 
				min: 0, 
				max: 5, 
				ticks: {
				  stepSize: 1,
				  display: true 
				}
			}
		}
	}

	return <Radar options={options} data={data} />
}
